// ▶ O que a ficha do produto mostra, visualizando, para um campo sem valor.
//
// Até 03/09/2026 a ficha ESCONDIA o rótulo inteiro quando o campo vinha vazio
// ("nove rótulos sem nada do lado escondem os dois que têm"). No teste real
// ela achou o efeito colateral: produto com pouco dado cadastrado (a maioria)
// abria mostrando quase nada, e pareceu que a tela estava quebrada. Agora todo
// campo aparece sempre, e o vazio vira travessão -- o vendedor vê o formato
// inteiro do produto e sabe o que falta preencher.
export function textoOuTraco(valor: string): string {
  return valor.trim() !== '' ? valor : '—'
}
